import { Text, View } from 'react-native';

import {
    createResponsiveComponent,
    type ResponsiveViewDefaultStyles,
} from './createResponsiveComponent';

/**
 * The `Responsive` API is designed to concisely express a responsive pattern in a performant way.
 * `Responsive` focuses on declarative expressions of the different styles at the different breakpoints (`mobile`, `tablet`, and `desktop`).
 *
 * `Responsive` exports two responsive component types: View, and Text, but you can also create your own using `Responsive.createResponsiveComponent()`.
 *
 * Because the entire configuration is declarative, we are be able to implement optimizations for SSR for example.
 */
export const Responsive = {
    /** Make any React component Responsive. Used to create Responsive.View, etc. */
    createResponsiveComponent,
    /**
     * Responsive variants of the basic native View. Accepts mobile, tablet and desktop styles.
     */
    View: createResponsiveComponent(View),
    /**
     * Responsive variants of the basic native Text. Accepts mobile, tablet and desktop styles.
     */
    Text: createResponsiveComponent(Text),
};

export type { ResponsiveViewDefaultStyles };
